import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles({
  depositContext: {

    fontFamily: "'Segoe UI Variable Static Text 300', sans-serif",
    fontSize: '16px',
    marginRight: '2px',
    width: '130%'
  },
  espacios: {
    marginLeft: "10%"
  },
  textStyle: {

    fontWeight: 'bold',
    marginTop: '10%',
    marginLeft: "23%",
    fontSize: "68px",
    fontFamily: "'Segoe UI Variable Static Text 700', sans-serif",

  }, textStyle1: {

    fontWeight: 'bold',
    marginTop: '10%',
    marginLeft: "13%",
    fontSize: "68px",
    fontFamily: "'Segoe UI Variable Static Text 700', sans-serif",

  }
});



export default function InfoBascula({ max, dataBascula, porcentage, total, total_users }) {
  const classes = useStyles();

  return (
    <>
    <Typography align="center" alignItems="center" style={{ fontWeight: 'bold', fontSize: "34px" }}color='primary'>
        Información general
      </Typography>

      <Grid container style={{ marginTop: "1%" }} alignItems="center" justifyContent="center" spacing={4}>
        <Grid item>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column">
              <Grid item xs>


                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <div>
                    <Typography component="p" align="center" variant="h2" className={(total !== 0 ? classes.textStyle1 : classes.textStyle)} color='primary'>
                      {total}
                    </Typography>
                    <Typography color="textSecondary" align="center" className={classes.depositContext}>
                      Usuarios Filtrados
                    </Typography>
                  </div>

                  <div className={classes.espacios}>
                    <Typography component="p" align="center" variant="h2" className={classes.textStyle} color='primary'>
                      {total_users}
                    </Typography>
                    <Typography color="textSecondary" align="center" className={classes.depositContext}>
                      Total De Usuarios
                    </Typography>
                  </div>

                  <div className={classes.espacios}>
                    <Typography component="p" align="center" variant="h2" className={classes.textStyle} color='primary'>
                      {porcentage === "NaN" ? "-" : porcentage}%
                    </Typography>
                    <Typography color="textSecondary" align="center" className={classes.depositContext}>
                      Porcentaje de Uso
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>

        </Grid>
      </Grid>
    </>
  );
}
